import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useApi, errMsg } from "@/lib/api";
import { useMember } from "@/context/MemberContext";
import { fmt } from "@/lib/dates";

export const SwapOfferDialog = ({ shift, employees, onClose, onSaved }) => {
  const api = useApi();
  const { member } = useMember();
  const [target, setTarget] = useState("all");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (shift) {
      setTarget("all");
      setNote("");
    }
  }, [shift]);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/swaps", { shift_id: shift.id, target_user_id: target === "all" ? null : target, note });
      toast.success("Dienst aangeboden. Je krijgt bericht als iemand hem overneemt.");
      onSaved?.();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!shift} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="swap-offer-dialog">
        <DialogHeader>
          <DialogTitle>Dienst aanbieden</DialogTitle>
          {shift && <DialogDescription className="capitalize">{fmt(shift.date, "EEEE d MMMM")} · {shift.start}–{shift.end}{shift.position ? ` · ${shift.position}` : ""}</DialogDescription>}
        </DialogHeader>
        <div className="grid gap-4">
          <div>
            <Label>Aan wie?</Label>
            <Select value={target} onValueChange={setTarget}>
              <SelectTrigger className="mt-1.5" data-testid="swap-target-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="all" data-testid="swap-target-all">Het hele team</SelectItem>
                {employees.filter((e) => e.user_id !== member.user_id).map((e) => (
                  <SelectItem key={e.user_id} value={e.user_id} data-testid={`swap-target-${e.user_id}`}>{e.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="swap-note">Toelichting (optioneel)</Label>
            <Input id="swap-note" value={note} maxLength={200} onChange={(e) => setNote(e.target.value)} placeholder="Bijv. familiebezoek" className="mt-1.5" data-testid="swap-note-input" />
          </div>
          <p className="text-xs text-slate-500">Een collega neemt de dienst over, daarna keurt je manager de ruil goed. Tot die tijd blijft de dienst van jou.</p>
        </div>
        <DialogFooter>
          <Button onClick={submit} disabled={busy} data-testid="swap-offer-submit-button">Aanbieden</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
